<template>
  <div :class="`main-layout main-layout-${id}`">
    <!-- // TODO ส่วนที่ใช้ในการ player video -->
    <div :class="`layout-player layout-player-${id}`">
      <div :class="`layout-player-content layout-player-content-${id}`">
        <div :class="`player-content player player-content-${id} player-${id}`" :id="`player-${id}`" />
        <div v-if="!camera" :class="`player-content profile player-content-${id} profile-${id}`">
          <v-icon :class="`profile-icon profile-icon-${id}`">mdi-account-outline</v-icon>
        </div>
      </div>
    </div>
    <!-- // TODO ส่วนที่ใช้ในการจัดการ status ต่างๆ -->
    <div v-show="checkMainUser === 'MainDisplay'" :class="`layout layout-status layout-${id} layout-status-${id}`">
      <v-icon v-if="!camera" class="mr-2">mdi-camera-off</v-icon>
      <v-icon v-if="!microphone">mdi-microphone-off</v-icon>
    </div>
    <!-- // TODO ส่วนที่ใช้ในการจัดการ title name -->
    <div :class="`layout layout-title layout-${id} layout-title-${id}`">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    checkMainUser: {
      type: String,
      default: 'SubDisplay'
    },
    title: {
      type: String,
      default: 'Undefined'
    },
    camera: {
      type: Boolean,
      default: false
    },
    microphone: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: Date.now().toString()
    }
  }
}
</script>

<style lang="css" scoped>
.main-layout {
  width: 100%;
  height: 100%;
  background: blue;
  position: relative;
   border-radius: inherit;
}

.main-layout .layout {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* // #  ส่วนที่ใช้ในการจัดการเล่น Video --------------------------------------- */
.layout-player {
  width: 100%;
  height: 100%;
  background: black;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  border-radius: inherit;
}
.layout-player .layout-player-content {
  width: 100%;
  height: 100%;
  /* background: green; */
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;

}
/* // # สำหรับจัดการ element ที่ใช้ในกาก playvideo */
.layout-player .layout-player-content .player-content {
  width: 100%;
  height: 100%;
  border-radius: inherit !important;
}

/* // # สำหรับจัดการ element ของ icon เวลาปิดกล้อง */
.layout-player .layout-player-content .player-content.profile {
  /* background: rgb(11, 230, 175) !important; */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-content: center;
}

.layout-player .layout-player-content .player-content.profile i {
  font-size: 48px;
  color: gray;
}

.layout-player .layout-player-content .player-content.player {
  /* background: purple; */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  border-radius: inherit !important;
}

::v-deep .layout-player .layout-player-content .player-content.player div{
  border-radius: inherit !important;
}

/* // # ส่วนที่ใช้ในการจัดการสถานะ ------------------------------------------- */
.layout-status {
  /* background: pink; */
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.layout-status i {
  font-size: 18px;
  color: red;
}

/* // # ส่วนที่ใช้ในการจัดการส่วนแสดงชื่อ --------------------------------------- */
.layout-title {
  text-align: end;
  font-weight: 300;
  font-size: 12px;
  z-index: 1;
  /* background-color: rgba(0, 0, 0, 0.05); */
  /* background: none; */
  /* background: orange; */
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;

  color: gray;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Fix Image Resize Of Agora Default */
::v-deep .agora_video_player {
  object-fit: contain !important;
  border-radius: inherit !important;
}
</style>
